
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.458 0L9.697 4.492c-.339.583-.63 1.073-1.167 1.598-.572.397-.945.84-1.715 1.178l-2.217.595-3.931.374c1.26.175 2.52.35 3.78.536.875.199 1.446.502 2.111.957.502.502.852 1.05.91 1.762l-.408 4.55-1.062 11.445 2.474-8.447 1.82-6.732c.583-1.155 1.283-1.668 2.368-2.193l7.408-1.657-5.541-.968-2.217-.327c-.607-.268-.863-.688-1.062-1.283l.21-5.88z","fill":"#342F2C"}})])
          )
        }
      }
    